import script from "./add.vue?vue&type=script&setup=true&lang=ts"
export * from "./add.vue?vue&type=script&setup=true&lang=ts"

import "./add.vue?vue&type=style&index=0&id=71f5dce0&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f5dce0"]])

export default __exports__